import { formatMoney } from '../../utility/helpers/commonFunction';

/** Horizontal spacing between every summary-table column. */
export const TAX_SUMMARY_COLUMN_GAP = 12;

/** Fixed-width columns per spec; every other column shares the leftover space. */
const FIXED_TAX_NAME_WIDTH = 170;
const FIXED_APPLICABLE_ITEMS_WIDTH = 100;

const colFixed = (width) => ({ width, flexGrow: 0, flexShrink: 0 });
const colFlex = { flexGrow: 1, flexShrink: 1, flexBasis: 0 };

/**
 * Column set for the tax summary table. US shops get a leading Tax Code column.
 * Tax Name and Applicable Items are fixed width; the rest expand to fill the row,
 * so any number of tax codes renders without the columns drifting out of line.
 */
export const getTaxSummaryColumns = (isUsShop) =>
    [
        isUsShop ? { key: 'taxCode', label: 'Tax Code', style: colFlex } : null,
        { key: 'taxName', label: isUsShop ? 'Tax Name' : 'Tax', style: colFixed(FIXED_TAX_NAME_WIDTH) },
        { key: 'rate', label: 'Rate', style: colFlex },
        { key: 'items', label: 'Applicable Items', style: colFixed(FIXED_APPLICABLE_ITEMS_WIDTH) },
        { key: 'taxable', label: 'Taxable', style: colFlex },
        { key: 'amount', label: 'Tax Amount', style: colFlex, align: 'right' },
    ].filter(Boolean);

/** Resolves a single cell's text for the given column and tax row. */
export const getTaxSummaryCellValue = (column, tax) => {
    const itemCount = tax?.appliesTaxItemCount ?? tax?.taxItemCount ?? 0;
    const totalItemCount = tax?.totaItemCount ?? tax?.totalItemCount ?? 0;

    switch (column.key) {
        case 'taxCode':
            return tax?.taxCode || tax?.taxName || '';
        case 'taxName':
            return tax?.taxName || tax?.taxCode || '';
        case 'rate':
            return tax?.taxPercentage != null && tax?.taxPercentage !== '' ? `${tax.taxPercentage}%` : '';
        case 'items':
            return `${itemCount} of ${totalItemCount}`;
        case 'taxable':
            return formatMoney(tax?.taxableAmount);
        case 'amount':
            return formatMoney(tax?.taxAmount);
        default:
            return '';
    }
};
